import '../../styles/web-components/carousel-selector.scss';
import '../../styles/templates/_collection-v2.scss';
import { getAlternateTemplate } from '../services/template.service';
import { refreshWishlistIcons } from '../services/wishlist.service';
import Splide from "@splidejs/splide";
import { DESKTOP_WIDTH, TABLET_WIDTH } from '../vue/constants/devices';
const defaultCarouselOptions = {
    mediaQuery: "min",
    gap: "8px",
    type: 'slide',
    perPage: 2,
    arrows: true,
    pagination: false,
    breakpoints: {
        [TABLET_WIDTH]: {
            perPage: 3
        },
        [DESKTOP_WIDTH]: {
            gap: "24px"
        }
    }
};
class CarouselSelector extends HTMLElement {
    static get observedAttributes() {
        return ["selected-cta-index"];
    }
    carousel = null;
    loadingSpinner = null;
    headerCopy = this.getAttribute('header-copy');
    subheaderCopy = this.getAttribute('subheader-copy');
    // normally we'd use the above header and subheader attributes
    // but the design team requested we have a different look for promos
    promoTitle = this.getAttribute('promo-title');
    promoOffer = this.getAttribute('promo-offer');
    promoCode = this.getAttribute('promo-code');
    numProducts = +this.getAttribute('num-products') || 6;
    toCollectionText = this.getAttribute('to-collection-text') || 'Shop the Collection';
    constructor() {
        super();
        this.addEventListener('click', async (e) => {
            const target = e.target;
            if (target.matches(".carousel-selector__cta:not(.carousel-selector__cta--selected)")) {
                this.updateHeader(target);
                // eslint-disable-next-line wc/no-constructor-attributes
                this.setAttribute('selected-cta-index', target.dataset.ctaIndex);
            }
        });
        this.addEventListener("click", async (e) => {
            const target = e.target;
            if (target.matches(".js-product-option:not(.product-option--selected)")) {
                e.stopPropagation();
                const initialColorSwatches = target.closest(".product-grid-item-v2__product-swatch-container");
                if (initialColorSwatches) {
                    initialColorSwatches.querySelectorAll(".js-product-option").forEach(c => c.classList.remove("product-option--selected"));
                    target.classList.add("product-option--selected");
                    const initialScrollLeft = initialColorSwatches.scrollLeft;
                    const collectionHandle = target.closest('.js-collection-render-test-result').dataset.collectionHandle;
                    const productHandle = target.dataset.productHandle;
                    const productCardHTML = await getAlternateTemplate(`/collections/${collectionHandle}/products/${productHandle}`, 'plp-card');
                    const productCardEl = target.closest(".boost-pfs-filter-product-item");
                    productCardEl.innerHTML = productCardHTML;
                    const newColorSwatches = productCardEl.querySelector('.product-grid-item-v2__product-swatch-container');
                    newColorSwatches.replaceWith(initialColorSwatches);
                    initialColorSwatches.scrollTo(initialScrollLeft, 0);
                    productCardEl.querySelectorAll('img[data-src]').forEach(img => {
                        img.src = img.dataset.src;
                        img.srcset = img.dataset.srcset || '';
                        img.removeAttribute('data-srcset');
                        img.removeAttribute('data-src');
                    });
                    refreshWishlistIcons('.boost-pfs-filter-products');
                }
            }
        });
        window.addEventListener('resize', () => {
            this.updateArrowPosition();
        });
    }
    connectedCallback() {
        this.render();
        this.loadingSpinner = this.querySelector('loading-spinner');
        this.carousel = new Splide(this.querySelector('.splide'), defaultCarouselOptions);
        this.carousel.mount();
        const firstCta = this.querySelector('.carousel-selector__cta');
        if (firstCta) {
            this.updateHeader(firstCta);
            this.fetchAndRenderCollection(firstCta.dataset.ctaIndex);
        }
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (!this.carousel || oldValue === newValue)
            return;
        switch (name) {
            case 'selected-cta-index':
                this.fetchAndRenderCollection(newValue);
                break;
            default:
                break;
        }
    }
    render() {
        this.innerHTML = `
    <div class="carousel-selector__container">
      <div class="carousel-selector__left-container">
        <div class="carousel-selector__header-container"></div>
        <div class="carousel-selector__cta-container">
          ${this.renderCTAs()}
        </div>
      </div>
      <div class="carousel-selector__right-container js-collection-render-test-result">
        <loading-spinner show="false"></loading-spinner>
        <section class="splide">
          <div class="splide__track">
            <ul class="splide__list"></ul>
          </div>
        </section>
      </div>
      </div>`;
    }
    renderCTAs() {
        return [1, 2, 3, 4, 5].map(i => {
            const ctaCopy = this.getAttribute(`cta-copy-${i}`);
            const ctaHandle = this.getAttribute(`cta-handle-${i}`);
            // the only required attributes are ctaCopy and ctaHandle
            if (ctaCopy && ctaHandle) {
                return `
          <button
            class="carousel-selector__cta"
            data-cta-index="${i}"
            data-collection-handle="${ctaHandle}"
            data-collection-filters="${this.getAttribute(`cta-collection-filters-${i}`) || ''}"
            data-cta-header="${this.getAttribute(`cta-header-copy-${i}`) || ''}"
            data-cta-subheader="${this.getAttribute(`cta-subheader-copy-${i}`) || ''}"
            data-cta-promo-title="${this.getAttribute(`cta-promo-title-${i}`) || ''}"
            data-cta-promo-offer="${this.getAttribute(`cta-promo-offer-${i}`) || ''}"
            data-cta-promo-code="${this.getAttribute(`cta-promo-code-${i}`) || ''}"
          >
            ${ctaCopy}
          </button>`;
            }
            return '';
        }).join('');
    }
    async fetchAndRenderCollection(ctaIndex) {
        console.log('CTA Index:', ctaIndex);
        let selectedCta = null;
        this.querySelectorAll('.carousel-selector__cta').forEach(c => {
            if (c.dataset.ctaIndex === ctaIndex) {
                c.classList.add('carousel-selector__cta--selected');
                selectedCta = c;
            }
            else {
                c.classList.remove('carousel-selector__cta--selected');
            }
        });
        const collectionHandle = selectedCta.dataset.collectionHandle;
        const collectionFilters = selectedCta.dataset.collectionFilters;
        // Fetch and render the collection data here
        const resp = await fetch(`/collections/${collectionHandle}?sections=collection-product-cards&${collectionFilters}`);
        const json = await resp.json();
        const parser = new DOMParser();
        const doc = parser.parseFromString(json['collection-product-cards'], 'text/html');
        const styles = new Set(doc.querySelectorAll('link[rel="stylesheet"]'));
        styles.forEach(style => {
            if (!document.head.querySelector(`link[href="${style.href.replace("https:", "")}"]`)) {
                document.head.appendChild(style);
            }
        });
        const productList = Array.from(doc.querySelectorAll(".boost-pfs-filter-product-item")).slice(0, this.numProducts).map(el => {
            const li = document.createElement('li');
            li.className = 'splide__slide';
            li.appendChild(el);
            return li;
        });
        // design asked for the option to randomize the products in cases where we pull from the same collection
        // for example, if each CTA just has a different filter applied. the randomization provides visual variety
        if (this.getAttribute('randomize-products') === 'true') {
            productList.sort(() => Math.random() - 0.5);
        }
        const toCollectionCard = document.createElement('li');
        toCollectionCard.className = 'splide__slide';
        const collectionUrl = `/collections/${collectionHandle}${mapShopifyFiltersToBoostFilters(collectionFilters)}`;
        toCollectionCard.innerHTML = `
      <a href="${collectionUrl}" class="carousel-selector__to-collection-card">
        <span>${this.toCollectionText}</span>
      </a>
    `;
        productList.push(toCollectionCard);
        const results = this.querySelector('.js-collection-render-test-result ul');
        results.replaceChildren(...productList);
        results.dataset.collectionHandle = collectionHandle;
        results.querySelectorAll('img[data-src]').forEach((img, i) => {
            if (i === 0) {
                img.addEventListener('load', () => {
                    this.updateArrowPosition();
                }, { once: true });
            }
            img.src = img.dataset.src;
            img.srcset = img.dataset.srcset || '';
            img.removeAttribute('data-srcset');
            img.removeAttribute('data-src');
        });
        this.carousel?.refresh().go(0);
        refreshWishlistIcons('.boost-pfs-filter-products');
    }
    updateArrowPosition() {
        if (this.carousel) {
            const arrows = this.carousel.root.querySelectorAll('.splide__arrow');
            const firstSlide = this.carousel.Components.Elements.slides[0];
            if (firstSlide) {
                const slideImg = firstSlide.querySelector('.boost-pfs-filter-product-item-image');
                if (slideImg) {
                    const imgHeight = slideImg.offsetHeight;
                    if (imgHeight === 0)
                        return;
                    arrows.forEach(arrow => {
                        arrow.style.top = `${imgHeight / 2}px`;
                    });
                }
            }
        }
    }
    updateHeader(target) {
        if (target.dataset.ctaHeader) {
            this.headerCopy = target.dataset.ctaHeader;
        }
        if (target.dataset.ctaSubheader) {
            this.subheaderCopy = target.dataset.ctaSubheader;
        }
        if (target.dataset.ctaPromoTitle) {
            this.promoTitle = target.dataset.ctaPromoTitle;
        }
        if (target.dataset.ctaPromoOffer) {
            this.promoOffer = target.dataset.ctaPromoOffer;
        }
        if (target.dataset.ctaPromoCode) {
            this.promoCode = target.dataset.ctaPromoCode;
        }
        const headerContainer = this.querySelector('.carousel-selector__header-container');
        if (headerContainer) {
            console.log("Updating header to:", this.headerCopy, this.subheaderCopy);
            headerContainer.innerHTML = `
        ${this.headerCopy ? `<h2 class="carousel-selector__header">${this.headerCopy}</h2>` : ''}
        ${this.subheaderCopy ? `<p class="carousel-selector__subheader">${this.subheaderCopy}</p>` : ''}
        ${this.promoTitle ? `<h2 class="carousel-selector__promo-title">${this.promoTitle}</h2>` : ''}
        ${this.promoOffer ? `<p class="carousel-selector__promo-offer">${this.promoOffer}</p>` : ''}
        ${this.promoCode ? `<p class="carousel-selector__promo-code">${this.promoCode}</p>` : ''}`;
        }
    }
}
if (!window.customElements.get("carousel-selector")) {
    customElements.define("carousel-selector", CarouselSelector);
}
function mapShopifyFiltersToBoostFilters(shopifyFilters) {
    const boostFilters = shopifyFilters.split('&').map(filter => {
        const [key, value] = filter.split('=');
        if (key.startsWith('filter.v.option.fit') || key.startsWith('filter.v.option.size')) {
            return `pf_opt_${key.replace('filter.v.option.', '')}=${value}`;
        }
        else if (key.startsWith('filter.v.option.color')) {
            return `pf_t_color=color%3A${value.toLowerCase()}`;
        }
        else {
            return null;
        }
    }).filter((f) => f !== null).join('&');
    return boostFilters ? `?${boostFilters}` : '';
}
